import { FC, useState } from 'react';
import EditorImg from 'lowcode/components/EditorImg';
import EfSwiperLevel2 from '@elem/ui/ef-swiper-level2';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { useRouter } from 'next/router';

const IconList = () => {
    const { t } = useLang('dp3.landing.SwiperJpC');
    const listA = [
        {
            icon: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718349193596/air_condition.png',
            title: t('item_icon1_label'),
            desc: t('item_icon1_desc'),
        },
        {
            icon: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718349193596/air_condition.png',
            title: t('item_icon2_label'),
            desc: t('item_icon2_desc'),
        },
        {
            icon: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718349193596/air_condition.png',
            title: t('item_icon3_label'),
            desc: t('item_icon3_desc'),
        },
        {
            icon: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718349193596/air_condition.png',
            title: t('item_icon4_label'),
            desc: t('item_icon4_desc'),
        },
        {
            icon: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718349193596/air_condition.png',
            title: t('item_icon5_label'),
            desc: t('item_icon5_desc'),
        },
        {
            icon: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718349193596/air_condition.png',
            title: t('item_icon6_label'),
            desc: t('item_icon6_desc'),
        },
    ];
    return (
        <div className="icon-list">
            {listA.map((item: any, index: number) => {
                return (
                    <div className="icon-item" key={index}>
                        <div className="icon-item-icon">
                            <EditorImg pc={item.icon} />
                        </div>
                        <div className="icon-item-title">{item.title}</div>
                        <div className="icon-item-desc">{item.desc}</div>
                    </div>
                );
            })}
        </div>
    );
};

const TheComp: FC = () => {
    const { t } = useLang('dp3.landing.SwiperJpC');
    const { locale } = useRouter();
    // const itemA = {
    //     pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718850267743/a1%20(1).jpg',
    //     upTitle: t('item1_t'),
    //     subtitle: t('item1_l'),
    //     desc: t('item1_r'),
    // };
    // const ListChildB = () => {
    //     return (
    //         <div className="comp-item">
    //             <div className="comp-item-up-title">{itemA.upTitle}</div>
    //             <div className="comp-item-content comp-item-content-jpb">
    //                 <div className="comp-item-content-jpb-img">
    //                     <EditorImg pc={itemA.pc} />
    //                 </div>
    //                 <div className="comp-item-content-jpb-icons">
    //                     <IconList />
    //                 </div>
    //             </div>
    //             <LRMessage lTitle={itemA.subtitle} rTitle={itemA.desc} />
    //         </div>
    //     );
    // };
    // const [listB, setListB] = useState([
    //     {
    //         pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718850381452/b1%20(1).jpg',
    //         upTitle: t('item2_t'),
    //         subtitle: t('item2_l'),
    //         desc: t('item2_r'),
    //     },
    //     {
    //         isChildNode: true,
    //         ChildNodeB: <ListChildB />,
    //     },
    //     {
    //         pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718850456564/c1%20(1).jpg',
    //         upTitle: t('item3_t'),
    //         subtitle: t('item3_l'),
    //         desc: t('item3_r'),
    //         tips: t('item3_tips'),
    //     },
    //     {
    //         pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716880029689/5.png',
    //         upTitle: t('item4_t'),
    //         subtitle: t('item4_l'),
    //         desc: t('item4_r'),
    //     },
    // ]);
    const [listA, setListA] = useState([
        {
            pc:
                locale === 'cn'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1737776630222/3_1.jpg'
                    : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719052014173/a1.jpg',
            h5List:
                locale === 'cn'
                    ? [
                          'https://websiteoss.ecoflow.com/upload/image/1737776646421/3_1_1_M.jpg',
                          'https://websiteoss.ecoflow.com/upload/image/1739180780303/3_1_2_M.jpg',
                      ]
                    : [
                          'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719052041093/b1.jpg',
                          'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719052052241/b2.jpg',
                      ],
            upTitle: t('item2_t'),
            subtitle: t('item2_l'),
            desc: t('item2_r'),
            tips: t('item2_tips'),
        },
        {
            pc:
                locale === 'cn'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1739180607757/3_2.jpg'
                    : locale === 'jp'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1720419864009/Frame%201000007972%20(4).jpg'
                    : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719055994688/d1%20(1).jpg',
            h5List:
                locale === 'cn'
                    ? [
                          'https://websiteoss.ecoflow.com/upload/image/1737776810653/3_2_1_M.jpg',
                          'https://websiteoss.ecoflow.com/upload/image/1739180658851/3_2_2_M.jpg',
                      ]
                    : [
                          locale === 'jp'
                              ? 'https://websiteoss.ecoflow.com/upload/image/1720164777057/Frame%201000008465.jpg'
                              : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719055896615/c1%20(1).jpg',
                          'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719055911039/c2.png',
                      ],
            upTitle: t('item1_t'),
            subtitle: t('item1_l'),
            desc: t('item1_r'),
            // tips: t('item3_tips'),
        },
        {
            pc:
                locale === 'cn'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1737777184980/3_3.jpg'
                    : locale === 'jp'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1720164883969/Frame%201000008456%20(2).jpg'
                    : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718850381452/b1%20(1).jpg',
            //pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718850456564/c1%20(1).jpg',
            h5List:
                locale === 'cn'
                    ? [
                          'https://websiteoss.ecoflow.com/upload/image/1737777184811/3_3_1_M.jpg',
                          'https://websiteoss.ecoflow.com/upload/image/1737777185182/3_3_2_M.jpg',
                      ]
                    : [
                          locale === 'jp'
                              ? 'https://websiteoss.ecoflow.com/upload/image/1720165462789/Frame%201000008429.jpg'
                              : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718872143546/a1.jpg',
                          'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718872175994/a2.jpg',
                      ],
            upTitle: t('item3_t'),
            subtitle: t('item3_l'),
            desc: t('item3_r'),
            tips: t('item3_tips'),
        },
        {
            pc:
                locale === 'cn'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1737777300277/3_4.jpg'
                    : locale === 'jp'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1720165314936/Safeguard%20your%20data%20with%20a%20comprehensive%20UPS..jpg'
                    : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718850456564/c1%20(1).jpg',
            //pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716880029689/5.png',
            h5:
                locale === 'cn'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1737777300098/3_4_M.jpg'
                    : locale === 'jp'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1720165707456/Frame%201000008469.jpg'
                    : '',
            upTitle: t('item4_t'),
            subtitle: t('item4_l'),
            desc: t('item4_r'),
        },
    ]);

    return (
        <div
            id="dp3-teaser-E15"
            className={`Smoothly dp3-teaser-E ${styles.theComp} GtmModuleData-section`}
            data-section-id={'dp3-SwiperJpC'}
            data-section-title={t('title')}
        >
            <div className="dp3-module-box comp-module">
                <div className="dp3-title">{t('title')}</div>
                {/* <SwiperCommon list={listB}></SwiperCommon> */}
            </div>
            <EfSwiperLevel2 list={listA} hasLevel2={true} />
        </div>
    );
};

export default TheComp;
